module.exports = __webpack_public_path__ + "Roboto-Light.183079184d96a491f16e.eot";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Light.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Light.eot
// module chunks = 5